import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { SettlementPage } from './pages/SettlementPage';
import { ToastProvider } from './components/Toast';
import { ErrorBoundary } from './components/ErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

export function App(): JSX.Element {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ProtectedRoute>{(username) => <SettlementPage username={username} />}</ProtectedRoute>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
